export default function getScoreRangeName(score) {
  const maxRange = 9;
  return Math.min(maxRange, Math.trunc(score));
}
